Promise.all([
  import('./article-listing.scss'),
  import('../../plugins/semantic/popup'),
  import('../../plugins/semantic/popup.css'),
  import('../../plugins/semantic/checkbox.css'),
  import('../../plugins/semantic/checkbox'),
  import('../../scripts/dbs/dbs.utilities.querystring'),
  import('../../plugins/searchable-multi-select-dropdown/jquery.dropdown.css'),
  import('../../plugins/searchable-multi-select-dropdown/jquery.dropdown.min.js'),
]).then(() => {
  $('.widget.article-listing').each(function (i, el) {
    $(el).data('widget', new ArticleListing(el))
    $(el).data('widget').init()
  })
})

function ArticleListing(el) {
  const self = this
  self.el = $(el)

  let dataEndpoint = $(el).attr('data-endpoint')
  if (dataEndpoint !== undefined && dataEndpoint.length && dataEndpoint.includes('blog/list')) {
    self.articleListing = require('./article-blog-listing.hbs')
  } else {
    self.articleListing = require('./article-listing.hbs')
  }

  self.totalCount = 0
  self.offset = 0
  self.pageSize = 0

  self.qs = new dbs.utilities.querystring()

  self.search = function (clear, disableHistory) {
    self.el.find('.mobile-filters .state-filter').popup('hide')

    if (self.el.find('.mobile-filters.blog').length) {
      if (self.el.find('.dropdown-option.dropdown-chose').length) {
        self.el
          .find('.mobile-filters .type-filter')
          .html('Tag (' + self.el.find('.dropdown-option.dropdown-chose').length + ')')
      } else {
        self.el.find('.mobile-filters .type-filter').html('Tag')
      }
    } else {
      self.el.find('.mobile-filters .type-filter').popup('hide')
    }

    self.el.find('.load-more-container').hide()

    const filters = {
      journeyguid: self.el.attr('data-journey'),
      location: null,
      type: null,
      offset: self.offset,
      pageSize: self.pageSize,
      path: window.location.pathname,
    }

    if (!self.el.hasClass('journey-listing')) {
      if (self.el.find('.filters .filter-set[data-category="location"] input:checked').length) {
        filters.location = self.el.find('.filters .filter-set[data-category="location"] input:checked').val()
      }

      if (self.el.find('.filters .filter-set[data-category="type"] input:checked').length) {
        filters.type = self.el.find('.filters .filter-set[data-category="type"] input:checked').val()
      }

      if (self.el.find('.mobile-filters.blog').length) {
        if (self.el.find('.ui.popup.mobile-state-filter input:checked').length) {
          filters.location = self.el.find('.ui.popup.mobile-state-filter input:checked').val()
        }
      }

      if (self.el.find('.blog-tag-select').length && self.el.find('.dropdown-main .dropdown-chose').length) {
        filters.type = []
        self.el.find('.dropdown-main .dropdown-chose').each(function (i, el) {
          filters.type.push($(el).data('value'))
        })
      }
    } else {
      if (self.el.find('.filters .filter-set[data-category="location"] input:checked').length) {
        filters.location = []
        self.el.find('.filters .filter-set[data-category="location"] input:checked').each(function (i, el) {
          filters.location.push($(el).val())
        })
      }

      if (self.el.find('.filters .filter-set[data-category="type"] input:checked').length) {
        filters.type = []
        self.el.find('.filters .filter-set[data-category="type"] input:checked').each(function (i, el) {
          filters.type.push($(el).val())
        })
      }
    }

    if (!disableHistory) {
      let stateFilters = {}

      if (filters.location) {
        stateFilters.location = filters.location
      }

      if (filters.type) {
        stateFilters.type = filters.type
      }

      self.newsFilterPushState(stateFilters)
    }

    // send filters to ajax
    $.ajax({
      url: $(el).attr('data-endpoint'),
      type: $(el).attr('data-method'),
      data: JSON.stringify(filters),
      dataType: 'json',
      contentType: 'application/json',
    })
      .done(function (data) {
        // if clear true delete

        if (clear) {
          self.el.find('.results .articles, .results .message').remove()
        }

        self.totalCount = parseInt(data.TotalCount)
        self.offset = parseInt(data.Offset)
        self.pageSize = parseInt(data.PageSize)

        const html = self.articleListing({
          data: data,
        })
        self.el.find('.results').append(html)

        if (data.Message && data.Message.length && self.el.find('.results .ui.message').length < 1) {
          self.el.find('.results').append('<div class="ui message">' + data.Message + '</div>')
        }

        if (self.totalCount > self.offset + self.pageSize) {
          self.el.find('.load-more-container').show()
        } else {
          self.el.find('.load-more-container').hide()
        }
      })
      .fail(function () {
        // TODO decide what happens on fail
      })
  }

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('ArticleListing init', self)
    }
    self.el.css('opacity', 1)
    self.el.find('.ui.checkbox').checkbox()
    self.setFiltersFromUrl()

    if (!self.el.hasClass('journey-listing')) {
      // SYNC
      self.el.find('.mobile-filters input[type="checkbox"]').on('change', function () {
        if ($(this).parents('.mobile-state-filter').length) {
          self.el.find('.mobile-filters .state-filter').html($(this).val())
        }
        if ($(this).parents('.mobile-type-filter').length) {
          self.el.find('.mobile-filters .type-filter').html($(this).val())
        }
        $(this).parents('.ui.popup').find('input[type="checkbox"]:checked').not($(this)).prop('checked', false)
        // uncheck all main form checkboxes
        self.el.find('.filters input[type="checkbox"]').prop('checked', false)
        // sync with mobile checkboxes
        self.el.find('.mobile-filters input[type="checkbox"]').each(function (i, el) {
          if ($(el).is(':checked')) {
            self.el.find('.filters input[value="' + $(el).attr('value') + '"]').prop('checked', true)
          }
        })
        if (self.el.find('.mobile-filters.blog').length) {
          if ($(this).parents('.ui.popup.mobile-state-filter').length) {
            self.el
              .find('.mobile-filters.blog .ui.popup.mobile-type-filter input[type="checkbox"]')
              .prop('checked', false)
            self.el.find('.mobile-filters .type-filter').html('Tag')
          }
          if ($(this).parents('.ui.popup.mobile-type-filter').length) {
            self.el
              .find('.mobile-filters.blog .ui.popup.mobile-state-filter input[type="checkbox"]')
              .prop('checked', false)
            self.el.find('.mobile-filters.blog .state-filter').html('State')
          }
        }
        self.offset = 0
        self.search(true)
      })
      self.el.find('.filters input[type="checkbox"]').on('change', function () {
        if ($(this).parents('.category-state.filter-set').length) {
          self.el.find('.mobile-filters .state-filter').html($(this).val())
        }
        if ($(this).parents('.category-type.filter-set').length) {
          self.el.find('.mobile-filters .type-filter').html($(this).val())
        }
        $(this).parents('.filter-set').find('input[type="checkbox"]:checked').not($(this)).prop('checked', false)
        // uncheck all mobile form checkboxes
        self.el.find('.mobile-filters input[type="checkbox"]').prop('checked', false)
        // sync with desktop checkboxes
        self.el.find('.filters input[type="checkbox"]').each(function (i, el) {
          if ($(el).is(':checked')) {
            self.el.find('.mobile-filters input[value="' + $(el).attr('value') + '"]').prop('checked', true)
          }
        })
        if (self.el.find('.blogtag.label.wrapper').length) {
          if ($(this).parents('.filter-set.category-state').length) {
            if ($(this).is(':checked')) {
              self.el.find('.filter-set.category-type input[type="checkbox"]').prop('checked', false)
              self.el.find('.blogtag.label.wrapper').show()
            } else {
              self.el.find('.clear-filters').click()
            }
          }
          if ($(this).parents('.filter-set.category-type').length) {
            if ($(this).is(':checked')) {
              self.el.find('.filter-set.category-state input[type="checkbox"]').prop('checked', false)
              self.el.find('.blogtag.label.wrapper').show()
            } else {
              self.el.find('.clear-filters').click()
            }
          }
          self.el.find('.blog-filter-text').text($(this).next('span').html().toUpperCase())
        }
        self.offset = 0
        self.search(true)
      })
      self.el.find('.blog-times').on('click', function () {
        self.el.find('.clear-filters').click()
      })
    } else {
      self.el.find('.mobile-filters input[type="checkbox"]').on('change', function () {
        if ($(this).parents('.mobile-state-filter').length) {
          self.el.find('.filters .category-state input[type="checkbox"]').prop('checked', false)
          // sync with mobile checkboxes
          self.el.find('.mobile-filters .mobile-state-filter input[type="checkbox"]').each(function (i, el) {
            if ($(el).is(':checked')) {
              self.el.find('.filters .category-state input[value="' + $(el).attr('value') + '"]').prop('checked', true)
            }
          })
        }

        if ($(this).parents('.mobile-type-filter').length) {
          self.el.find('.filters .category-type input[type="checkbox"]').prop('checked', false)
          // sync with mobile checkboxes
          self.el.find('.mobile-filters .mobile-type-filter input[type="checkbox"]').each(function (i, el) {
            if ($(el).is(':checked')) {
              self.el.find('.filters .category-type input[value="' + $(el).attr('value') + '"]').prop('checked', true)
            }
          })
        }
        self.offset = 0
        self.search(true)
      })
      self.el.find('.filters input[type="checkbox"]').on('change', function () {
        if ($(this).parents('.category-state.filter-set').length) {
          self.el.find('.mobile-filters .mobile-state-filter input[type="checkbox"]').prop('checked', false)
          // sync with desktop checkboxes
          self.el.find('.filters .category-state input[type="checkbox"]').each(function (i, el) {
            if ($(el).is(':checked')) {
              self.el
                .find('.mobile-filters .mobile-state-filter input[value="' + $(el).attr('value') + '"]')
                .prop('checked', true)
            }
          })
        }

        if ($(this).parents('.category-type.filter-set').length) {
          self.el.find('.mobile-filters .mobile-type-filter input[type="checkbox"]').prop('checked', false)
          // sync with desktop checkboxes
          self.el.find('.filters .category-type input[type="checkbox"]').each(function (i, el) {
            if ($(el).is(':checked')) {
              self.el
                .find('.mobile-filters .mobile-type-filter input[value="' + $(el).attr('value') + '"]')
                .prop('checked', true)
            }
          })
        }
        self.offset = 0
        self.search(true)
      })
    }

    self.statePopped = false

    // handle popstate
    window.onpopstate = function (event) {
      self.statePopped = true

      // window.dbs.globalEvents.emit('search_popstate', event.state);
      self.setFiltersFromUrl()

      if (event.state) {
        self.search(true, true)
      }

      self.statePopped = false
    }

    self.loadMore = function () {
      self.offset = self.offset + self.pageSize
      self.search(false, true)
    }

    self.el.find('.mobile-filters .state-filter').popup({
      popup: self.el.find('.mobile-state-filter'),
      on: 'click',
      position: 'bottom right',
      lastResort: 'bottom right',
    })
    self.el.find('.mobile-filters .type-filter').popup({
      popup: self.el.find('.mobile-type-filter'),
      on: 'click',
      position: 'bottom right',
      lastResort: 'bottom right',
    })
    self.el.find('.clear-filters').click(function (event) {
      event.preventDefault()
      self.el.find('.filters input[type="checkbox"], .mobile-filters input[type="checkbox"]').prop('checked', false)
      self.offset = 0
      self.search(true)
      self.el.find('.mobile-filters .state-filter').html('State')
      self.el.find('.mobile-filters .type-filter').html('Type')
      self.el.find('.blogtag.label.wrapper').hide()
      if (self.el.find('.mobile-filters.blog').length) {
        self.el.find('.mobile-filters .type-filter').html('Tag')
      }
      if (self.el.find('.dropdown-option.dropdown-chose').length) {
        self.el.find('.dropdown-option.dropdown-chose').click()
      }
    })

    self.el.find('.load-more').click(function (event) {
      event.preventDefault()
      self.loadMore()
    })

    self.el
      .find('.article-blog-load-more')
      .unbind('click')
      .click(function (event) {
        event.preventDefault()
        self.loadMore()
      })

    self.search(true, true)
  }

  self.newsFilterPushState = function (filters) {
    // create a state object with all filters
    let url = window.location.pathname.replace(/\/+/g, '/')
    history.pushState({ filters: filters }, $(' head title').html(), url + '?' + $.param(filters))
  }

  self.setFiltersFromUrl = function () {
    self.location = self.qs.getParameter('location')
    self.type = self.qs.getParameter('type')

    // clear all filters
    self.el.find('.filters input[type="checkbox"]').prop('checked', false)
    self.el.find('.mobile-filters input[type="checkbox"]').prop('checked', false)

    if (self.location) {
      self.el.find('input[value="' + self.location + '"]').prop('checked', true)
      self.el.find('.mobile-filters .state-filter').html(self.location)
    }

    if (self.type) {
      self.el.find('input[value="' + self.type + '"]').prop('checked', true)
      self.el.find('.mobile-filters .type-filter').html(self.type)
    }
  }

  let firstClick = true
  if (self.el.find('.blog-tag-select').length) {
    self.el.find('.blog-tag-select').dropdown({
      multipleMode: 'label',
      dataAjaxFunction: GetContentCategories(el, ''),
      input: '<input class="blog-search-input" type="search" placeholder="Select a filter"/>',
      searchNoData: '<li class="no-matching-tags" onclick="return false">&nbsp;&nbsp;&nbsp;no matching tags found</li>',
      choice: function () {
        if (self.el.find('.no-matching-tags').length) {
          return false
        }
        self.el.find('.dropdown-main li').click(function () {
          if (self.el.find('.blog-search-input').val().length) {
            self.el.find('.blog-search-input').val('')
          }
          if (
            self.el.find('.blog-tag-filter.visible').length &&
            self.el.find('.mobile-filters.blog .blog-search-input').val().length
          ) {
            self.el.find('.mobile-filters.blog .blog-search-input').val('')
          }
        })
        if (!self.el.find('.blog-search-input').val().length && !firstClick) {
          rePopulateCategories(self.el.find('.blog-search-input'))
        }
        if (
          self.el.find('.blog-tag-filter.visible').length &&
          !firstClick &&
          !self.el.find('.mobile-filters.blog .blog-search-input').val().length
        ) {
          rePopulateCategories(self.el.find('.mobile-filters.blog .blog-search-input'))
        }
        self.offset = 0
        self.search(true)
        firstClick = false
      },
    })
  }
}

function rePopulateCategories(element) {
  const e = jQuery.Event('keyup')
  e.which = 112
  e.altKey = true
  element.trigger(e)
}

function GetContentCategories(el, location) {
  return $.ajax({
    url: $(el).attr('data-content-categories-endpoint') + '?location=' + location,
    type: $(el).attr('data-method'),
    dataType: 'json',
    contentType: 'application/json',
    success: function () {},
  })
}
